export default __webpack_public_path__ + "static/media/matilda_2.309ef9e1.jpeg";